import request from "./requesters/product.request";

const referenceTypeService = {
  getAllReferenceTypes: () => request.get(`/reference-types`),
};

export default referenceTypeService;
